import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {License} from "../../../models/licenses-model/license.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  DevicesDevicesService
} from "../../../services/devices-services/devices-devices-services/devices-devices.service";
import {LicensesService} from "../../../services/licenses-service/licenses.service";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";
import {tap} from "rxjs/internal/operators/tap";
import {catchError} from "rxjs/internal/operators/catchError";

@Component({
  selector: 'app-device-update-license-dialog',
  templateUrl: './device-update-license-dialog.component.html',
  styleUrls: ['./device-update-license-dialog.component.scss']
})
export class DeviceUpdateLicenseDialogComponent implements OnInit, OnDestroy {

  licenses: License[];
  error: string;
  basicDataForm = new FormGroup({
    licenseDescription: new FormControl(null, Validators.required),
    selectedLicense: new FormControl(null, Validators.required),
  });
  addNewDeviceSubscription: Subscription;
  getLicensesSubscription: Subscription;

  constructor(public dialogRef: MatDialogRef<DeviceUpdateLicenseDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Object,
              public devicesService: DevicesDevicesService,
              private licensesService: LicensesService,
              private snackbarService: SnackBarService) {
  }

  ngOnInit() {
    this.basicDataForm.patchValue({
      licenseDescription: this.data['licenseDescription']
    });
    this.getLicenses();
  }

  public getLicenses() {
    this.getLicensesSubscription = this.licensesService.getLicenses().subscribe(
      (res) => {
        this.licenses = res;
        this.basicDataForm.patchValue({
          selectedLicense: this.licenses[0]
        });
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public updateDeviceLicense() {
    this.error = '';
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewDeviceSubscription = this.devicesService.updateDeviceLicense(
        this.data['deviceInternalId'],
        this.basicDataForm.get('selectedLicense').value.InternalId)
        .pipe(
          tap(o => this.dialogRef.close()),
          tap(o => this.snackbarService.open('devices-page.snackbar messages.link device success', 'success')),
          tap(o => this.devicesService.refreshDevices()),
          catchError(err => this.error += err['error']['message'])
        ).subscribe();
    } else {
      this.error += validation;
    }
  }

  public validateForm() {
    // if (!this.basicDataForm.get('token').valid) {
    //   return 'devices-page.snackbar messages.token iot error';
    // } if (!this.basicDataForm.get('selectedCenter').valid) {
    //   return 'devices-page.snackbar messages.selected center iot error';
    // }
    if (!this.basicDataForm.get('selectedLicense').valid) {
      return 'devices-page.snackbar messages.selected license iot error';
    } else {
      return true;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.addNewDeviceSubscription) { this.addNewDeviceSubscription.unsubscribe(); }
    if (this.getLicensesSubscription) { this.getLicensesSubscription.unsubscribe(); }
  }

}
